import { render, staticRenderFns } from "./TaskApproveRejectDialog.vue?vue&type=template&id=55373e46"
import script from "./TaskApproveRejectDialog.vue?vue&type=script&lang=js"
export * from "./TaskApproveRejectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports